export default __webpack_public_path__ + "static/media/SaveIcon.19c03015.svg";